export const digestOutput = {
    'SHA-1': 160,
    'SHA-256': 256,
    'SHA-384': 384,
    'SHA-512': 512,
};
export const SALT_RANDOM_BYTES = 24;
export const NONCE_RANDOM_BYTES = 24;
export const AES_CRYPTO_KEY_BITS = 256;
export const AES_CRYPTO_BLOCK_SIZE_BITS = 128;
export const AES_CRYPTO_IV_LENGTH = AES_CRYPTO_BLOCK_SIZE_BITS / 8;
export const RSA_CRYPTO_MODULUS_SIZE = 2048;
export const RSA_CRYPTO_ENCRYPT_HASH = 'SHA-1';
export const RSA_CRYPTO_SIGN_HASH = 'SHA-256';
export const PASSWORD_DERIVE_HASH_FUNCTION = 'SHA-512';
export const AES_SECRET_DERIVE_HASH_FUNCTION = 'SHA-512';
export const AES_SECRET_DERIVE_INFO = 'Key Wrapping and Unwrapping';
export const RSA_ENCRYPTION_ALGO_NAME = 'RSA-OAEP';
export const RSA_SIGNING_ALGO_NAME = 'RSA-PSS';
export const AES_ALGO_NAME = 'AES-GCM';
export const AES_KW_ALGO_NAME = 'AES-KW';
export const RSA_ENCRYPTION_ALGO_PARAMS = {
    algorithm: {
        name: RSA_ENCRYPTION_ALGO_NAME,
        hash: RSA_CRYPTO_ENCRYPT_HASH,
    },
};
export const RSA_SIGNING_ALGO_PARAMS = {
    algorithm: {
        name: RSA_SIGNING_ALGO_NAME,
        hash: RSA_CRYPTO_SIGN_HASH,
    },
};
export const AES_ENCRYPTION_ALGO_PARAMS = {
    algorithm: {
        name: AES_ALGO_NAME,
        length: AES_CRYPTO_KEY_BITS,
    },
};
export const AES_KW_ENCRYPTION_ALGO_PARAMS = {
    algorithm: {
        name: AES_KW_ALGO_NAME,
        length: AES_CRYPTO_KEY_BITS,
    },
};
